var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UIKit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-560.000000, -1284.000000)",
    fill: "#A5BFCE",
    fillRule: "nonzero",
    id: "diamond"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M576.111321,1284 C576.253673,1284 576.382157,1284.07031 576.462014,1284.18985 L579.930897,1289.36457 C580.031608,1289.51926 580.021164,1289.71965 579.906583,1289.86377 L570.322921,1301.84443 C570.156255,1302.05186 569.843745,1302.05186 569.677079,1301.84443 L560.093417,1289.86377 C559.978836,1289.72315 559.968392,1289.51926 560.069103,1289.36457 L563.541445,1284.18985 C563.617843,1284.07031 563.749785,1284 563.888679,1284 L576.111321,1284 Z M575.441166,1285.68742 L573.468883,1285.68742 L575.264056,1289.06225 L577.639151,1289.06225 L575.441166,1285.68742 Z M568.423543,1285.68742 L566.631829,1289.06225 L573.368171,1289.06225 L571.572964,1285.68742 L568.423543,1285.68742 Z M564.558834,1285.68742 L562.360849,1289.06225 L564.735944,1289.06225 L566.531117,1285.68742 L564.558834,1285.68742 Z M563.065727,1290.74967 L567.222127,1296.3744 L564.850524,1290.74967 L563.065727,1290.74967 Z M566.63878,1290.74967 L570,1299.30276 L573.36122,1290.74967 L566.63878,1290.74967 Z M572.777873,1296.3744 L576.93078,1290.74967 L575.146017,1290.74967 L572.777873,1296.3744 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.31942f14.svg";
export { ForwardRef as ReactComponent };